import defaultClient from '@/plugins/axios/defaultClient'

export default {
  putCollectionAccounts(uuid, account) {
    return defaultClient.put(`/collection-accounts/${uuid}/`, account)
  },
}
